import { render, staticRenderFns } from "./FindWorkspace.vue?vue&type=template&id=5f081614&scoped=true&"
import script from "./FindWorkspace.vue?vue&type=script&lang=js&"
export * from "./FindWorkspace.vue?vue&type=script&lang=js&"
import style0 from "./FindWorkspace.vue?vue&type=style&index=0&id=5f081614&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f081614",
  null
  
)

export default component.exports